import { useCallback } from "react";

import { myLensesActionType } from "../../../../analytics/event-creators";
import { useBlizzardEvents } from "../../../../analytics/hooks";
import { useSelectedFeature } from "../../../../shared/hooks";

interface UseGameLensToggleParams {
    setIsGameUserProvided: (isGameUserProvided: boolean) => void;
}

const gameLensToggleLabels = {
    set: "game_lens_toggle_set",
    unset: "game_lens_toggle_unset",
} as const;

export const useGameLensToggle = ({
    setIsGameUserProvided,
}: UseGameLensToggleParams): { handleGameLensToggle: (isGameLensChecked: boolean) => void } => {
    const { sendBlizzardEvent } = useBlizzardEvents();
    const { selectedFeature } = useSelectedFeature();

    const handleGameLensToggle = useCallback(
        (nextIsGameUserProvided: boolean) => {
            sendBlizzardEvent({
                event: "MYLENSES_ACTION",
                actionType: myLensesActionType.click,
                label: nextIsGameUserProvided ? gameLensToggleLabels.set : gameLensToggleLabels.unset,
                namespace: selectedFeature ?? "",
            });

            setIsGameUserProvided(nextIsGameUserProvided);
        },
        [selectedFeature, sendBlizzardEvent, setIsGameUserProvided],
    );

    return { handleGameLensToggle };
};
